import React from 'react';
import { AlertTriangleIcon, XIcon, ClockIcon, TruckIcon } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-8 md:py-12" data-id="element-229">
      <div className="bg-red-50 p-4 md:p-6 rounded-lg border border-red-200" data-id="element-230">
        <div className="flex items-center mb-3 md:mb-4" data-id="element-231">
          <AlertTriangleIcon className="w-5 h-5 md:w-6 md:h-6 text-red-600 mr-2 flex-shrink-0" data-id="element-232" />
          <h3 className="text-lg md:text-xl font-bold text-red-600" data-id="element-233">
            Important: Supply Running Low
          </h3>
        </div>
        <p className="mb-4 md:mb-6 text-sm md:text-base" data-id="element-234">
          Due to overwhelming demand after Robert's story spread:
        </p>
        <ul className="space-y-2 md:space-y-3 mb-4 md:mb-6" data-id="element-235">
          <li className="flex items-center" data-id="element-236">
            <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500 mr-2 md:mr-3 flex-shrink-0" data-id="element-237" />
            <span className="text-sm md:text-base" data-id="element-238">
              <strong data-id="element-239">73%</strong> of current batch sold out
            </span>
          </li>
          <li className="flex items-center" data-id="element-240">
            <ClockIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500 mr-2 md:mr-3 flex-shrink-0" data-id="element-241" />
            <span className="text-sm md:text-base" data-id="element-242">
              <strong data-id="element-243">Limited</strong> quantities remaining
            </span>
          </li>
          <li className="flex items-center" data-id="element-244">
            <TruckIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500 mr-2 md:mr-3 flex-shrink-0" data-id="element-245" />
            <span className="text-sm md:text-base" data-id="element-246">
              Orders processed <strong data-id="element-247">first-come, first-served</strong>
            </span>
          </li>
        </ul>
        <blockquote className="italic border-l-4 border-red-300 pl-3 md:pl-4 py-1 md:py-2 text-sm md:text-base text-gray-700 mb-4 md:mb-6" data-id="element-248">
          "I hope every veteran and anyone else suffering can get this before it
          runs out." — Robert
        </blockquote>
        <div className="flex justify-center" data-id="element-249">
          <a href="https://tryvascura.com/products/cayenne-pepper-supplement-liquid-drops" className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 md:py-4 px-6 md:px-8 rounded-full shadow-lg transition duration-300 text-sm md:text-lg w-full" data-id="element-250">
            Claim Your Discount Before It's Gone →
          </a>
        </div>
      </div>
    </section>;
}